import React from 'react';
import classNames from 'classnames';
import Form from 'react-bootstrap/Form';
import { getAddressDisplay } from '../utils';
import { Address } from '../services/models';
import { withWrapperAutoSuggest } from './WrapperAutoSuggest';

const ManualAddressForm = ({
  handleChange,
  values,
  touched,
  errors,
  onAddressSelect,
  setManualAddressEnabled,
  columnClass = 'md',
}) => {
  const setAddressValue = (
    street: string,
    city: string,
    suburb: string,
    postcode: string,
  ) => {
    const addressObject: Address = {
      line1: street,
      line2: suburb,
      line3: city + ' ' + postcode,
      label: '',
      postcode: postcode,
      state: city,
      dpid: '0',
      address_id: '0',
    };
    addressObject.label = getAddressDisplay(addressObject);
    onAddressSelect(addressObject);
  };

  const onSelect = (contentType: string, value: string) => {
    let cityContent = values.city;
    let suburbContent = values.suburb;
    let postcodeContent = values.postcode;
    switch (contentType) {
      case 'city':
        cityContent = value;
        suburbContent = '';
        postcodeContent = '';
        break;
      case 'suburb':
        suburbContent = value;
        postcodeContent = '';
        break;
      default:
        postcodeContent = value;
    }
    setAddressValue(values.street, cityContent, suburbContent, postcodeContent);
  };

  const onUnSelect = (contentType: string) => {
    let cityContent = '';
    let suburbContent = '';
    let postcodeContent = '';
    if (contentType === 'suburb') {
      cityContent = values.city;
    } else if (contentType === 'postcode') {
      cityContent = values.city;
      suburbContent = values.suburb;
    }
    setAddressValue(values.street, cityContent, suburbContent, postcodeContent);
  };

  const cityClasses = ['col-12', 'manual-address-suggestion-input'];
  const suburbClasses = [
    'col-8',
    'pad-lft-0-md-lg',
    'manual-address-suggestion-input',
  ];
  const postcodeClasses = [
    'col-4',
    'pad-lft-0',
    'manual-address-suggestion-input',
  ];

  cityClasses.push('col-' + columnClass + '-6');
  suburbClasses.push('col-' + columnClass + '-4');
  postcodeClasses.push('col-' + columnClass + '-2');

  return (
    <>
      <div className="col-12">
        <Form.Group controlId="formStreet">
        <div
            onClick={() => setManualAddressEnabled(false)}
            className="manual-address-toggle"
          >
            Want automatic address suggestions?
          </div>
          <Form.Label>Street</Form.Label>
          <Form.Control
            type="text"
            name="street"
            placeholder="Enter your street"
            value={values.street}
            onChange={e => {
              handleChange(e);
              setAddressValue(
                e.target.value,
                values.city,
                values.suburb,
                values.postcode,
              );
            }}
            isInvalid={touched.street && !!errors.street}
          />
          <Form.Control.Feedback type="invalid">
            {errors.street}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className={cityClasses.join(' ')}>
        <Form.Group controlId="formCity">
          <Form.Label>City</Form.Label>
          <div
            className={classNames({
              'is-invalid': !values.city && !!errors.city && touched.city,
            })}
          >
            <Form.Control
              key="city"
              as={withWrapperAutoSuggest('city', 'Type your city')}
              onSelect={(value: string) => onSelect('city', value)}
              onUnSelect={() => onUnSelect('city')}
              onChange={handleChange}
              value={values.city}
              isInvalid={!values.city && !!errors.city}
              hasError={!values.city && !!errors.city && touched.city}
            />
          </div>
          <Form.Control.Feedback type="invalid">
            {errors.city}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className={suburbClasses.join(' ')}>
        <Form.Group controlId="formSuburb">
          <Form.Label>Suburb</Form.Label>
          <div
            className={classNames({
              'is-invalid': !values.suburb && !!errors.suburb && touched.suburb,
            })}
          >
            <Form.Control
              key="suburb"
              as={withWrapperAutoSuggest(
                'suburb',
                'Type your suburb',
                values.city,
              )}
              onSelect={(value: string) => onSelect('suburb', value)}
              onUnSelect={() => onUnSelect('suburb')}
              onChange={handleChange}
              value={values.suburb}
              isInvalid={!values.suburb && !!errors.suburb}
              hasError={!values.suburb && !!errors.suburb && touched.suburb}
            />
          </div>
          <Form.Control.Feedback type="invalid">
            {errors.suburb}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className={postcodeClasses.join(' ')}>
        <Form.Group controlId="formPostcode">
          <Form.Label>Postcode</Form.Label>
          <div
            className={classNames({
              'is-invalid':
                !values.postcode && !!errors.postcode && touched.postcode,
            })}
          >
            <Form.Control
              key="postcode"
              as={withWrapperAutoSuggest(
                'postcode',
                'Type',
                values.city,
                values.suburb,
              )}
              onSelect={(value: string) => onSelect('postcode', value)}
              onUnSelect={() => onUnSelect('postcode')}
              onChange={handleChange}
              value={values.postcode}
              isInvalid={!values.postcode && !!errors.postcode}
              hasError={
                !values.postcode && !!errors.postcode && touched.postcode
              }
            />
          </div>
          <Form.Control.Feedback type="invalid">
            {errors.postcode}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
    </>
  );
};

export default ManualAddressForm;
